import { useState } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import { api } from 'api';
import InvoiceModal from 'app/components/InvoiceModal';
import { InvoiceFormProps } from 'app/components/InvoiceModal/InvoiceModal.types';
import useInvoices from 'app/hooks/useInvoices';
import { paths } from 'app/paths';
import { defaultValues, parseFormToApi } from './InvoiceNew.utils';

const InvoiceNew = (): React.ReactElement => {
  const navigate = useNavigate();
  const { mutateAsync } = api.useMutation('post', '/invoices');
  const { refetch } = useInvoices();

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleClose = (id?: number) => {
    navigate(id ? paths.invoices.show(id) : paths.invoices.base(), {
      replace: true,
    });
  };

  const onSubmit = async (data: InvoiceFormProps) => {
    setIsSubmitting(true);
    try {
      const { id } = await mutateAsync({
        body: { invoice: parseFormToApi(data) },
      });
      await refetch();
      toast.success('Invoice created successfully.');
      handleClose(id);
    } catch {
      toast.error('Failed to create invoice. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>New invoice</title>
      </Helmet>
      <InvoiceModal
        onSubmit={onSubmit}
        onClose={handleClose}
        title="New invoice"
        saveAction={isSubmitting ? 'Creating...' : 'Create invoice'}
        defaultValues={defaultValues}
        isSubmitting={isSubmitting}
      />
    </>
  );
};

export default InvoiceNew;
